var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "海报设置",
        width: "800px",
        loading: _vm.loading,
        height: "auto",
        top: "100px",
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "posterList_page_wrap" }, [
        _c(
          "div",
          {
            ref: "scrollView",
            staticClass: "posterList",
            style: `transform: translateX(${_vm.scrollStep}px)`,
          },
          [
            _c("div", { staticClass: "posterListView" }, [
              _c(
                "div",
                {
                  staticClass: "posterListCover addView",
                  on: { click: _vm.onhandleAdd },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("span", { staticClass: "addViewText" }, [
                    _vm._v("新增样式"),
                  ]),
                ]
              ),
            ]),
            _vm._l(_vm.list, function (item, index) {
              return _c("div", { key: index, staticClass: "posterListView" }, [
                _c(
                  "div",
                  {
                    staticClass: "posterListCover",
                    class: { selectPoster: _vm.selectId === item.id },
                    on: {
                      click: function ($event) {
                        return _vm.onhandleSelect(item)
                      },
                    },
                  },
                  [
                    _c("el-image", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        src: item.coverUrl,
                        alt: "",
                        fit: "contain",
                        "preview-src-list": [item.coverUrl],
                      },
                    }),
                  ],
                  1
                ),
                _vm.selectId === item.id
                  ? _c("img", {
                      staticClass: "posterSelectImg",
                      attrs: {
                        src: require("@/assets/image/liveRoom/posterSelect.png"),
                        alt: "",
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "posterListTitle text_hidden" },
                  [
                    _c("textShowMore", {
                      attrs: { "line-clamp": 1, text: item.posterName },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "posterListViewBtn" }, [
                  _c(
                    "div",
                    {
                      staticClass: "posterSetting",
                      on: {
                        click: function ($event) {
                          return _vm.onChange(item, index)
                        },
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { value: item.isDefault, label: 0 } },
                        [_vm._v("设为默认")]
                      ),
                    ],
                    1
                  ),
                  item.isSystem !== 0
                    ? _c("i", {
                        staticClass: "el-icon-delete",
                        on: {
                          click: function ($event) {
                            return _vm.onhandleDel(item)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ])
            }),
          ],
          2
        ),
        _c("div", { staticClass: "previous_page" }, [
          _c("div", {
            staticClass: "previous_page_btn",
            on: { click: _vm.onhandlePrevious },
          }),
        ]),
        _c("div", { staticClass: "next_page" }, [
          _c("div", {
            staticClass: "next_page_btn",
            on: { click: _vm.onhandleNext },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }